import { PropsWithChildren, ReactNode, useContext, useEffect, useState } from 'react';
import { Expandable } from '@fabric-ds/react';
import SidebarContext from 'state/SidebarContext';

interface TitleContainerProps {
    title: string;
    icon: ReactNode;
}
interface ContainerProps extends TitleContainerProps {
    containerClass?: string;
    tracker: (finnkode: string) => void;
}

const MobileDividerLine = () => (
    <div
        className="border-b  h-1 mb-24 absolute right-0 md:hidden"
        style={{ bottom: '-25px', width: '90%' }}
    ></div>
);
const TitleContainer = ({ icon, title }: PropsWithChildren<TitleContainerProps>) => (
    <>
        <div className="flex space-x-8 text-16 items-center">
            {icon}
            <p className="m-0 text-gray-700" style={{ fontWeight: '300' }}>
                {title}
            </p>
        </div>
        <MobileDividerLine />
    </>
);

const ExpandableDataContainer = ({
    title,
    icon,
    containerClass = '',
    tracker,
    children,
}: PropsWithChildren<ContainerProps>) => {
    const [open, setOpen] = useState<boolean>(false);
    const { finnkode } = useContext(SidebarContext);

    useEffect(() => {
        if (open) {
            tracker(finnkode);
        }
    }, [open]);

    return (
        <div className={`flex items-center w-full max-w-full border-t ${containerClass}`}>
            <Expandable
                title={<TitleContainer icon={icon} title={title} />}
                box
                animated
                expanded={open}
                onChange={setOpen}
                className="w-full md:px-8 "
                buttonClass="w-full w-max-full flex items-center px-0 md:px-16"
            >
                {children}
            </Expandable>
        </div>
    );
};

export default ExpandableDataContainer;
